
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"28","viewBox":"0 0 31 28","width":"31","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m3.9 23.8334v.1h.1 13.3333.1v-.1-1.25-.1h-.1-1.6291v-6.275c0-1.1881-.3542-2.2477-1.0622-3.1752-.6927-.9074-1.5968-1.4876-2.7087-1.7387v-.5236c0-.3466-.1257-.6377-.3764-.86565-.2483-.22563-.5468-.3385-.8902-.3385-.3435 0-.642.11287-.89022.3385-.25075.22795-.37648.51905-.37648.86565v.5236c-1.11181.2511-2.01261.8314-2.69853 1.739-.70094.9276-1.05147 1.987-1.05147 3.1749v6.275h-1.65-.1v.1zm5.1.7333h-.1v.1c0 .4858.17788.9038.53004 1.2486.35099.3437.76466.5181 1.23666.5181.485 0 .9028-.1739 1.2478-.5189s.5188-.7627.5188-1.2478v-.1h-.1zm5.2542-2.0833h-7.1542v-6.275c0-1.0017.34746-1.8514 1.04397-2.5546.69626-.703 1.54211-1.0537 2.54353-1.0537 1.0014 0 1.8436.3506 2.5328 1.0533.6896.7032 1.0339 1.553 1.0339 2.555z","fill":"#957050","stroke":"#957050","stroke-width":".2"}}),_c('path',{attrs:{"d":"m21.3119 12c-.2099 0-.4121-.0871-.562-.2451l-3.1859-3.25242c-.3073-.32408-.3073-.85342 0-1.17714.3074-.32408.8094-.32408 1.1164 0l2.6089 2.64411 5.338-5.699c.2921-.33982.7945-.36359 1.1164-.04754.3223.30803.3448.8377.0451 1.17714l-5.8924 6.33145c-.1422.166-.3521.2685-.5696.2685z","fill":"#b2895f"}})])
          )
        }
      }
    